document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(location.search);

    if (params.get('send') === 'true') {
        const form = document.querySelector(`.pane-${params.get('formId')}`);

        if (form !== null) {
            $('html,body').animate(
                {
                    scrollTop: $(form).offset().top - 100,
                },
                500,
                'swing'
            );
        }
    }

    const referer = document.querySelector(`input.previous_referer`);
    if (referer) {
        referer.value = document.URL;
    }
});

class CustomFileInput {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.customFileInput = this.DOM.el.querySelector(`.custom-file-input`);
        this.DOM.customFileLabel = this.DOM.el.querySelector(`.custom-file-label`);

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        this.DOM.customFileInput.addEventListener('change', (event) => {
            const files = Array.from(event.target.files);
            this.DOM.customFileLabel.innerText = files.map(file => file.name).join(", ");
        });
    }
}

[...document.querySelectorAll('.custom-file')].forEach((node) => { new CustomFileInput(node); });
